import { Stack } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQualityControlTool } from '@/context/Qualitycontrol.context';
import { useDefaultComments } from '@/hooks/use-default-comments';
import { useQcMode } from '@/hooks/use-qcMode';
import AutocompleteField, {
  AutocompleteItem,
} from '../Common/Field/AutocompleteField';

const AgentPublicComment = () => {
  const { t } = useTranslation();

  const [defaultComment, setDefaultComment] = useState<AutocompleteItem | null>(
    null
  );

  const { data } = useDefaultComments('public');

  const { agentPublicComment, setAgentPublicComment } = useQualityControlTool();

  const { isViewMode } = useQcMode();

  const options: AutocompleteItem[] = useMemo(() => {
    return data ? data.map((d) => ({ label: d.name, value: d.code })) : [];
  }, [data]);

  const handleDefaultCommentChange = (
    selectedItem: AutocompleteItem | null
  ) => {
    setDefaultComment(selectedItem);
    if (selectedItem) setAgentPublicComment(selectedItem.label);
  };

  const handleCommentTextChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    setAgentPublicComment(value);
  };

  return (
    <Stack sx={{ gap: 2.5 }}>
      <AutocompleteField
        disabled={isViewMode}
        options={options}
        label={t('QC_V2.COMMON.DEFAULT_COMMENT')}
        value={defaultComment}
        onChange={(_, value) => handleDefaultCommentChange(value)}
        disableClearable
        showTooltip
        tooltipPlacement="left"
      />
      <TextField
        data-testid="public_comment_input_text"
        id="agentPublicComment"
        label={t('QC_V2.MAIN.QC_PUBLIC_COMMENT')}
        placeholder={t('QC_V2.MAIN.COMMENT_PLACEHOLDER')}
        value={agentPublicComment}
        disabled={isViewMode}
        onChange={handleCommentTextChange}
        multiline
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Stack>
  );
};

export default AgentPublicComment;
